<template>
    <div>
        <top-navbar></top-navbar>
<div>
  

<div class=" mb-5 background_color">
 

     <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> {{language[1]['Home']}} </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/setting/index"> {{language[9]['Manage Language']}} </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>  {{language[115]['Update All']}}</h6>
 
  <!-- <h6 class="custom-maintitle "><b>Issue Tracking</b></h6> -->

  <div class="container-fluid">
      <div style="border: 0px; padding: 0px; min-height:0px" class="navbar background_color">

        
  


        <div class="d-grid gap-2 d-md-flex justify-content-md-end">

    

 


</div>
</div>



<div class="card bdr-rad2 mt-1 shadow p-2 ">
<div class="card-body ">
 

    <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2" >
                              <tr class="custom-label2">
                                <th style="width: 20%;">#</th>
                              <th style="width: 20%;">Id </th>
                              <th  style="width: 30%;">{{language[85]['English']}} </th>
                              <th>{{language[86]['swedish']}} </th>
                              <th>Chinese</th>
                              <th>Japanese</th>
                              <th>Deutsch</th>
                           
                             
                           
                            
                              </tr>
                            </thead>
                            <tbody> 
                                <tr v-for="(lan, index) in all_data" :key="lan.id">
                                    <td>{{ index+1 }}</td>
                                    <td>{{ lan.id }}</td>
                                    <td>{{ lan.english }}</td>
                                    <td><input  v-model="lan.swedish"  style="font-size: small;" class="form-control bdr-rad" ></td>
                                    <td><input  v-model="lan.chinese"  style="font-size: small;" class="form-control bdr-rad" ></td>
                                    <td><input  v-model="lan.Japanese"  style="font-size: small;" class="form-control bdr-rad" ></td>
                                    <td><input  v-model="lan.Deutsch"  style="font-size: small;" class="form-control bdr-rad" ></td>
                                

                                </tr>

                                </tbody>
                                </table>
   

                                <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  @click="updatePage()" class="mr-1 btn btn-sm btn-outline-primary  mb-1 font-size_def bdr-rad">{{language[78]['Update']}}</button>
    </div>
    </div>         

  
</div>
</div>
</div>
<br><br>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        language:JSON.parse(authService.isLanguage()),
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 15,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
       
        all_data:[],
        fields:[],
        
      


        
      }

    },
    computed: {
     
    },
    created(){
     
      
  this.loadIssue();


    },
    mounted(){
     
      
     

    },
methods : {


  async updatePage() {
   
   try {
     const { data} = await  axios.post('/issuetracking/languageallupdate',{all_data:this.all_data},{
       headers:{
         'Authorization':'Bearer '+this.access_token,
         'Content-type': 'application/json',
        
       }
      });
      console.log(data);
      if(data.status==200){
        window.location.reload();
      }
     
     
     
      
     
   } catch (error) {
     console.log(error.response);
   }
 },
 
  Update(id){
    this.$router.push('/setting/update?id='+id);
  },
  LabelCreate(){
    this.$router.push('/setting/create');
  },

  loadIssue(id) {

this.filterOn = id;
  },

 
 




  async loadIssue() {
    console.log(this.access_token);
    try {
      const { data} = await  axios.get('/issuetracking/languageindex',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
         this.all_data = data.all_data;
        this.totalRows =  this.all_data.length;
      
    } catch (error) {
      console.log(error.response);
    }
  },
   

       


 
  


 


},

    components :{
        ContentFooter,
        TopNavbar
    },
  }

</script>
<style >

</style>